export const ACTIVITY_TYPES = ["walk", "run", "hike", "treadmill", "row", "cycle", "elliptical", "other"] as const;
export type ActivityType = (typeof ACTIVITY_TYPES)[number];

/**
 * How many "journey miles" one real mile of each activity is worth.
 * The Éowyn Challenge had no rules; everything counted at face value. Keep it
 * simple by default and let the owner tune it later.
 */
export const ACTIVITY_MULTIPLIER: Record<ActivityType, number> = {
  walk: 1,
  run: 1,
  hike: 1,
  treadmill: 1,
  row: 1,
  cycle: 1,
  elliptical: 1,
  other: 1,
};

export const isActivityType = (v: unknown): v is ActivityType =>
  typeof v === "string" && (ACTIVITY_TYPES as readonly string[]).includes(v);

export function journeyMeters(distanceMeters: number, type: ActivityType) {
  return distanceMeters * ACTIVITY_MULTIPLIER[type];
}
